import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { asTimeLeft } from 'src/app/shared/utils/tournament.utils';
import { GameInterfaceState } from '../../game/controllers/listeners/ux-game-listener';
import { GameId } from 'src/app/model/game/game-id';

@Component({
  selector: 'app-game-score',
  templateUrl: './game-score.component.html',
  styleUrls: ['./game-score.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameScoreComponent implements OnInit {
  @Input() gameName?: string;
  @Input({ required: true }) gameId!: GameId;
  @Input({ required: true }) gameInterfaceState!: GameInterfaceState;
  @Input({ required: true }) opponent!: string;
  @Input() opponentId?: string;
  @Input() score?: string;
  @Input() reward?: string;
  @Input() countdown?: number;
  @Input() tournamentCountdown?: number;
  @Input() bountyAmount?: number;

  @Output() opponentClicked = new EventEmitter<string>();
  @Output() backClicked = new EventEmitter<void>();
  @Output() closeClicked = new EventEmitter<void>();

  themeService = inject(ThemeService);
  translocoService = inject(TranslocoService);

  GameInterfaceState = GameInterfaceState;

  formattedTournamentCountdown: string | undefined;
  currencyIcon = this.themeService.currencyIcon();

  get gameNameStyles(): [string, string][] {
    const key = 'game-header-title';
    return [
      ['text-color', key],
      ['type', key],
    ];
  }

  get versusStyles(): [string, string][] {
    const key = 'game-header-versus';
    return [
      ['text-color', key],
      ['type', key],
    ];
  }

  get opponentStyles(): [string, string][] {
    const key = 'game-header-player';
    return [
      ['text-color', key],
      ['type', key],
      ['text-decoration', key],
    ];
  }

  get eventTimerStyles(): [string, string][] {
    const key = 'game-header-event-timer';
    return [
      ['text-color', key],
      ['type', key],
    ];
  }

  get eventCountdownStyles(): [string, string][] {
    const key = 'game-header-event-countdown';
    return [
      ['text-color', key],
      ['type', key],
    ];
  }

  get currencyPillStyles(): [string, string][] {
    const key = 'pill-currency';
    return [
      ['background', key],
      ['border-radius', key],
      ['text-color', `${key}-label`],
      ['type', `${key}-label`],
    ];
  }

  get scorePillStyles(): [string, string][] {
    const key = 'pill-score';
    return [
      ['background', key],
      ['border-radius', key],
      ['text-color', `${key}-label`],
      ['type', `${key}-label`],
    ];
  }

  async ngOnInit() {
    if (this.tournamentCountdown) {
      this.formattedTournamentCountdown = asTimeLeft(this.tournamentCountdown);
    }
  }

  isEnded(): boolean {
    return this.countdown !== undefined && this.countdown <= 0;
  }

  onBackClicked() {
    this.backClicked.emit();
  }

  onCloseClicked() {
    this.closeClicked.emit();
  }

  onOpponentClicked() {
    if (this.opponentId) {
      this.opponentClicked.emit(this.opponentId);
    }
  }

  get bountyAmountUSD(): number | undefined {
    if (this.bountyAmount) return this.bountyAmount / 100;
    return undefined;
  }
}
